import React, { Component } from "react";

export default class Overview extends Component {
  render() {
    return (
      <div>
        <div class="card-body">
          <div className="row">
            <div className="col-1">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ6Ke3SBsfFFo18l9VZbKWHH7j1bG9lOi1tHhMxSha2SiQcibyO&usqp=CAU"
                alt="some alt text"
              />
            </div>
            <div className="col-11">
              <h5 class="card-title">
                Content and TalentLMS<sub>(SAMP2)</sub>
              </h5>
              <a href="#admin/reports/course" class="btn btn-primary">
                Download Excel
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
